import React ,{ useState} from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate';
import {DatePicker} from '../../shared/DatePicker';
import { GetCumulativeDetailedIncomeReport } from '../../../api/services/finance';
import CheckboxWrapper from '../../shared/Checkbox';
import PropTypes from "prop-types";
import { useTextResources } from '../../../language'

const CumulativeDetailedIncomeReport = ({HotelID})=>{
    const [myTransformedData,setData] = useState([]);
    const [search, setSearchParams] = useState({});
    const text = useTextResources()

    const handleSearchComplete = (data, searchState) => {
        setSearchParams(searchState)
        setData(data)
    }
    const formatter = ({value})=>{
        return value.toFixed(2)
    }
    
    const gridOptions = {
        search: {
            title: text("CumulativeDetailedIncomeReport"),
            fields: [ 
                <DatePicker 
                    type="basic"
                    label="Date"
                    key="Date"
                />,
               <CheckboxWrapper
                    label="Click to compare" 
                    key="ComparedToLastYear"
                />
            ],
            api: GetCumulativeDetailedIncomeReport,
            spec: {
                HotelID:HotelID
            }
        },
        
        grid: {
            columns: [
                { name: 'TransactionCodeGroupName', title: 'Transaction Code' },
                { name: 'TransactionGroupName', title: 'Transaction Group Name' },
                { name: 'Period1', title: 'Daily', formatter },
                { name: 'Period2', title: 'Monthly', formatter },
                { name: 'Period3', title: 'Yearly', formatter },
                { name: 'Period4', title: 'Daily Last Year', formatter },
                { name: 'Period5', title: 'Monthly Last Year', formatter },
                { name: 'Period6', title: 'Yearly Last Year', formatter }
            ],
            customOptions:{
                overrideData:true,
                hidden:{
                    hiddenColumns: search.ComparedToLastYear ? 
                    [{columnName:  'TransactionGroupName'}]:
                    [{columnName:  'Period4'},{columnName:  'Period5'},{columnName:  'Period6'},{columnName:  'TransactionGroupName'}]
                }
            },
            selectable: false,
            tree: {
              getChildRows: (row, rootRows) => {
                  const childRows = rootRows.filter(r => r.ParentTransactionCodeGroupID === (row ? row.TransactionCodeGroupID : null));
                  return childRows.length ? childRows : null;
              },
              treeColumnName: "TransactionCodeGroupName"
            },
            pdf: true,
            export: true,
            excel: {
                grouping:  [{ columnName: "TransactionGroupName" }],
            },
            customCellCallback: ({row}) =>{
                if (row.IsStatisticsHeader) {
                    return <div></div>
                } else 
                return false
            },
            customTreeCellCallback: ({row}) =>{
                if (row.IsStatisticsHeader) {
                    return <div style={{fontWeight: "bold", fontSize: "larger"}}>{row.TransactionCodeGroupName}</div>
                } else 
                return false
            },
        }
        
    }

    return (<GridSearchTemplate options={gridOptions} onSearchComplete={handleSearchComplete} data={myTransformedData} />)
}
CumulativeDetailedIncomeReport.propTypes = {
    HotelID: PropTypes.number
}
export default CumulativeDetailedIncomeReport